import { useField } from 'formik';
import { dayjs, getUserTimezone } from '@koob/dates';
import { useState } from 'react';
import { FormLabel } from 'ui';
import TimePickerField from './TimePickerField';

const START_TIME = '12:00';
const END_TIME = '11:59';

const TimeRangePickerField = ({ name, label, timezone, disabled = false }) => {
  const [field, , { setValue }] = useField({ name });

  const [startTime, setStartTime] = useState(
    field.value && field.value.length > 0
      ? dayjs(field.value[0]).tz(timezone).format('HH:mm')
      : START_TIME,
  );
  const [endTime, setEndTime] = useState(
    field.value && field.value.length > 1
      ? dayjs(field.value[1]).tz(timezone).format('HH:mm')
      : END_TIME,
  );

  const updateFieldValues = (newStartTime, newEndTime) => {
    const startMoment =
      field.value && field.value.length > 0 ? dayjs(field.value[0]) : dayjs();
    const endMoment =
      field.value && field.value.length > 1
        ? dayjs(field.value[1])
        : dayjs().add(1, 'day');

    // Set the time on the hotel-tz day; the browser's day can differ (KD-3709)
    const newStart = startMoment
      .tz(timezone)
      .hour(dayjs(newStartTime, 'HH:mm').get('hour'))
      .minute(dayjs(newStartTime, 'HH:mm').get('minute'))
      .second(0);

    const newEnd = endMoment
      .tz(timezone)
      .hour(dayjs(newEndTime, 'HH:mm').get('hour'))
      .minute(dayjs(newEndTime, 'HH:mm').get('minute'))
      .second(59);

    setValue([newStart, newEnd]);
  };

  const changeStartTime = (value) => {
    setStartTime(value);
    updateFieldValues(value, endTime);
  };

  const changeEndTime = (value) => {
    setEndTime(value);
    updateFieldValues(startTime, value);
  };

  // Same clock as the user (e.g. Bangkok seen from Vietnam) needs no hint
  const at = field.value?.[0] ?? undefined;
  const hotelTime = dayjs(at).tz(timezone);
  const showTimezone =
    hotelTime.utcOffset() !== dayjs(at).tz(getUserTimezone()).utcOffset();

  return (
    <div className="flex flex-col gap-1">
      {Boolean(label) && (
        <FormLabel className="text-sm font-medium">{label}</FormLabel>
      )}
      <div className="flex items-center gap-3">
        <TimePickerField
          value={startTime}
          handleChange={changeStartTime}
          disabled={disabled}
        />

        <i className="fa-sharp fa-regular fa-arrow-right text-sm text-gray-500 flex-shrink-0" />

        <TimePickerField
          value={endTime}
          handleChange={changeEndTime}
          disabled={disabled}
        />
      </div>
      {showTimezone && (
        <span className="text-xs text-gray-500">
          {timezone} (UTC{hotelTime.format('Z')})
        </span>
      )}
    </div>
  );
};

export default TimeRangePickerField;
